//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { App_User } from '@/data/user_info'
const isIOS = wx.getSystemInfoSync().system.substring(0, 3).toLowerCase() === 'ios'
export default {
    data () {
        return {
            is_consultant: false
        }
    },
    mounted () {
        App_User.is_consultant().then((is_consultant) => {
            this.is_consultant = is_consultant
        })
    },
    methods: {
        showBillboard () {
            this.$emit('showBillboard')
        },
        onLikeConsult (e) {
            const { consultant } = this
            const liked = !consultant.is_liked
            this.$emit('likeConsultant', liked)
        },
        showShareOption () {
            if (this.is_consultant) {
                this.$emit('showShareOption')
            }
        },
        goWxCard() {
            this.$sendCtmEvtLog('置业顾问名片页-加我为好友点击')
            wx.navigateTo({
                url: `/consultants/card/wx_card/main?qr=${encodeURIComponent(this.consultant.weixin_qrcode_url)}&building_name=${this.consultant.building_name}`
            })
        }
    },
    props: {
        consultant: {
            type: Object
        }
    }
}
